module.exports = __webpack_public_path__ + "img/our6.3c047b2c.png";